import Badge from './Badge';
import { STAGE_COLORS } from '../../utils/constants';

export default function StageBadge({ stage }) {
  return (
    <Badge color={STAGE_COLORS[stage] || 'bg-gray-100 text-gray-700'}>
      {stage}
    </Badge>
  );
}
